import { createEvent, restore, sample } from 'effector'
import { ModerationTaskRequest } from './types'
import { fx } from '../../../../../libs'
import { RequestError } from '../../../../../shared/errorResponse'

export const moderationTaskSubmit = createEvent<ModerationTaskRequest>()

export const setError = createEvent<RequestError>()

export const $error = restore(setError, {
  message: '',
  code: 0,
})

export const moderationTask = fx<ModerationTaskRequest, void>({
  method: 'PUT',
  url: `/promo/golden_may/participant_task/`,
})

sample({
  // @ts-ignore
  clock: moderationTaskSubmit,
  fn: ({ id, status, declineReason }) => {
    return {
      url: `/promo/golden_may/participant_task/${id}`,
      body: {
        status,
        declineReason,
      },
    }
  },
  target: moderationTask,
})

sample({
  clock: moderationTask.failData,
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setError],
})
